import IconBase from './icon-base';

// eslint-disable-next-line react/prop-types
const IconDownload = ({ className, fill, height = '16px', hoverColor, width = '16px' }) => (
  <IconBase className={className} fill={fill} height={height} hoverColor={hoverColor} viewBox="0 0 16 16" width={width}>
    {/* eslint-disable max-len */}
    <path d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196666 15.0217 0.000666667 14.5507 0 14V11H2V14H14V11H16V14C16 14.55 15.8043 15.021 15.413 15.413C15.0217 15.805 14.5507 16.0007 14 16H2Z" />
  </IconBase>
);

export default IconDownload;
